import React from 'react';
import { withStyles } from  '@material-ui/styles'
import {
    Filter,
    SelectInput,
    NullableBooleanInput,
    SearchInput,
    ReferenceInput,
} from 'react-admin';

import { ApplicationStatusChoices } from '../../constants'
import { YearChoices, RegionChoices } from '../../../../constants/constants'

const styles = theme => ({
})

const ResultStatusChoices = [
  { id: 0, name: 'Undone'},
  { id: 1, name: 'Pass' },
  { id: 2, name: 'Failed' },
  { id: 3, name: 'Consider' },
]

const StudentApplicationFilter = (props) => {
  const { ...others } = props
  return (
    <Filter
      {...others}
    >
      <SearchInput source="name" alwaysOn />
      <SelectInput source='year' label='Year' choices={YearChoices} alwaysOn/>
      <SelectInput source='region' label='Region' choices={RegionChoices} alwaysOn/>

      <SelectInput source='application_status' label='Application Status' choices={ApplicationStatusChoices}/>
      <SelectInput source='review_status' label='Review Status' choices={ResultStatusChoices} />
      <SelectInput source='interview_status' label='Interview Status' choices={ResultStatusChoices} />
      <SelectInput source='assessment_status' label='Assessment Status' choices={ResultStatusChoices} />
      <SelectInput source='final_status' label='Final Status' choices={ResultStatusChoices} />

      <ReferenceInput label='Reviewer 1' source='reviewer_1' reference='student-application-reviewer'>
        <SelectInput source='display_name'/>
      </ReferenceInput>
      <ReferenceInput label='Reviewer 2' source='reviewer_2' reference='student-application-reviewer'>
        <SelectInput source='display_name' />
      </ReferenceInput>

      <ReferenceInput label='Interviewer 1' source='interviewer_1' reference='student-application-interviewer'>
        <SelectInput source='display_name' />
      </ReferenceInput>
      <ReferenceInput label='Interviewer 2' source='interviewer_2' reference='student-application-interviewer'>
        <SelectInput source='display_name' />
      </ReferenceInput>

      <ReferenceInput label='Assessor 1' source='assessor_1' reference='student-application-assessor'>
        <SelectInput source='display_name' />
      </ReferenceInput>
      <ReferenceInput label='Assessor 2' source='assessor_2' reference='student-application-assessor'>
        <SelectInput source='display_name' />
      </ReferenceInput>
      <ReferenceInput label='Assessor 3' source='assessor_3' reference='student-application-assessor'>
        <SelectInput source='display_name' />
      </ReferenceInput>

      <NullableBooleanInput source='my_review' label='My Review' defaultValue={true}/>
      <NullableBooleanInput source='my_interview' label='My Interview' defaultValue={true}/>
      <NullableBooleanInput source='my_assessment' label='My Assessment' defaultValue={true}/>
    </Filter>
  )
}

export default withStyles(styles)(StudentApplicationFilter)